import instance, { API_URL } from "../../../api";
import cookies from "react-cookies";
import { COOKIES } from "../../../helpers";

const cashierIdentityParam = (casherPhone, waiterId) =>
    waiterId
        ? `waiter_id=${encodeURIComponent(waiterId)}`
        : `casher_phone=${encodeURIComponent(casherPhone)}`;

const cashierBonusApi = {
    getCashierBonusAnalytics: async (branchId, dates = '') => {
        return await instance().get(`/analytics/branches/${branchId}/cashier-bonuses${dates}`)
            .then(res => res.data.data)
    },
    getGroupCashierBonusAnalytics: async (groupId, dates = '') => {
        return await instance().get(`/analytics/groups/${groupId}/cashier-bonuses${dates}`)
            .then(res => res.data.data)
    },
    getCashierTransactions: async (branchId, casherPhone, waiterId = '', dates = '', page = 1, limit = 50, sortBy = 'created_at', sortDir = 'desc') => {
        const identity = cashierIdentityParam(casherPhone, waiterId);
        const params = `${dates ? `${dates}&` : '?'}${identity}&page=${page}&limit=${limit}&sort_by=${sortBy}&sort_dir=${sortDir}`;
        return await instance().get(`/analytics/branches/${branchId}/cashier-transactions${params}`)
            .then(res => res.data.data)
    },
    getGroupCashierTransactions: async (groupId, casherPhone, waiterId = '', dates = '', page = 1, limit = 50, sortBy = 'created_at', sortDir = 'desc') => {
        const identity = cashierIdentityParam(casherPhone, waiterId);
        const params = `${dates ? `${dates}&` : '?'}${identity}&page=${page}&limit=${limit}&sort_by=${sortBy}&sort_dir=${sortDir}`;
        return await instance().get(`/analytics/groups/${groupId}/cashier-transactions${params}`)
            .then(res => res.data.data)
    },
    exportCashierBonusAnalytics: (branchId, dates = '') => {
        return fetch(`${API_URL}/analytics/branches/${branchId}/cashier-bonuses/export${dates}`, {
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/vnd.ms-excel;charset=UTF-8',
                Authorization: `Bearer ${cookies.load(COOKIES.TOKEN)}`
            },
            method: 'GET'
        }).then((response) => {
            response.blob().then((blob) => {
                const filename = decodeURI(response.headers.get('Content-Disposition')?.split('filename=')[1] || 'cashier_bonuses_report.xlsx')
                if ('msSaveOrOpenBlob' in window.navigator) {
                    navigator.msSaveBlob(blob, filename)
                } else {
                    const a = document.createElement('a')
                    document.body.appendChild(a)
                    a.href = window.URL.createObjectURL(blob)
                    a.download = filename
                    a.target = '_blank'
                    a.click()
                    a.remove()
                }
            });
            return {};
        })
    },
    exportCashierTransactions: (branchId, casherPhone, waiterId = '', dates = '') => {
        const params = `${dates ? `${dates}&` : '?'}${cashierIdentityParam(casherPhone, waiterId)}`;
        return fetch(`${API_URL}/analytics/branches/${branchId}/cashier-transactions/export${params}`, {
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/vnd.ms-excel;charset=UTF-8',
                Authorization: `Bearer ${cookies.load(COOKIES.TOKEN)}`
            },
            method: 'GET'
        }).then((response) => {
            response.blob().then((blob) => {
                const filename = decodeURI(response.headers.get('Content-Disposition')?.split('filename=')[1] || 'cashier_transactions_report.xlsx')
                if ('msSaveOrOpenBlob' in window.navigator) {
                    navigator.msSaveBlob(blob, filename)
                } else {
                    const a = document.createElement('a')
                    document.body.appendChild(a)
                    a.href = window.URL.createObjectURL(blob)
                    a.download = filename
                    a.target = '_blank'
                    a.click()
                    a.remove()
                }
            });
            return {};
        })
    },
}

export default cashierBonusApi;
